import { Maybe } from "true-myth";

import { IBlockModalData } from "components/schedule/time_block_modal";

import { trackEvent } from "helpers/analytics";
import { trackSaveShiftEvents } from "helpers/schedule/shifts";
import { IRole, IPosUser, IShift } from "types/schedules";

type BlockActionTypes =
  | ISaveShiftAction
  | IDeleteShiftAction
  | ISetBlockDataAction;

enum BlockTypeKeys {
  SAVE_SHIFT = "SCHEDULING/SHIFTS/SAVE_SHIFT",
  DELETE_SHIFT = "SCHEDULING/SHIFTS/DELETE_SHIFT",
  SET_BLOCK_MODAL_DATA = "SCHEDULING/SET_BLOCK_MODAL_DATA",
}

interface INewShift {
  employee: Maybe<IPosUser>;
  role: IRole;
  date: Date;
  startHour: number;
  startMinute: number;
  endHour: number;
  endMinute: number;
  uuid: string;
}

interface ISaveShiftAction {
  type: BlockTypeKeys.SAVE_SHIFT;
  shift: INewShift;
  existingShift: Maybe<IShift>;
  existingAssignee: Maybe<IPosUser>;
}

function saveShift(
  shift: INewShift,
  existingShift: Maybe<IShift>,
  existingAssignee: Maybe<IPosUser>
): ISaveShiftAction {
  trackSaveShiftEvents(shift, existingShift, existingAssignee);

  return {
    type: BlockTypeKeys.SAVE_SHIFT,
    shift,
    existingShift,
    existingAssignee,
  };
}

interface IDeleteShiftAction {
  type: BlockTypeKeys.DELETE_SHIFT;
  shift: IShift;
  assignee: Maybe<IPosUser>;
}

function deleteShift(
  shift: IShift,
  assignee: Maybe<IPosUser>
): IDeleteShiftAction {
  if (assignee.isJust()) {
    trackEvent("delete an assigned shift");
  } else {
    trackEvent("delete an unassigned shift");
  }
  return {
    type: BlockTypeKeys.DELETE_SHIFT,
    assignee,
    shift,
  };
}

interface ISetBlockDataAction {
  type: BlockTypeKeys.SET_BLOCK_MODAL_DATA;
  data: IBlockModalData | null;
}

type OpenBlockFunc = (blockModalData: IBlockModalData) => void;

function openBlockModal(data: IBlockModalData): ISetBlockDataAction {
  return {
    type: BlockTypeKeys.SET_BLOCK_MODAL_DATA,
    data,
  };
}

function closeBlockModal(): ISetBlockDataAction {
  return {
    type: BlockTypeKeys.SET_BLOCK_MODAL_DATA,
    data: null,
  };
}

export {
  BlockActionTypes,
  BlockTypeKeys,
  INewShift,
  deleteShift,
  openBlockModal,
  closeBlockModal,
  OpenBlockFunc,
  saveShift,
};
